// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    .form-check-input {
      cursor: pointer;
    }
    .form-check-input:checked {
      background-color: #4a0072;
      border-color: #4a0072;
    }
    .form-check-input:focus {
      border-color: #4a0072;
      box-shadow: 0 0 0 0.25rem rgba(74, 0, 114, 0.25);
    }
  `, "",{"version":3,"sources":["webpack://./libs/ui/src/lib/components/elements/zikata-switch/zikata-switch.component.ts"],"names":[],"mappings":";IACI;MACE,eAAe;IACjB;IACA;MACE,yBAAyB;MACzB,qBAAqB;IACvB;IACA;MACE,qBAAqB;MACrB,gDAAgD;IAClD","sourcesContent":["\n    .form-check-input {\n      cursor: pointer;\n    }\n    .form-check-input:checked {\n      background-color: #4a0072;\n      border-color: #4a0072;\n    }\n    .form-check-input:focus {\n      border-color: #4a0072;\n      box-shadow: 0 0 0 0.25rem rgba(74, 0, 114, 0.25);\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
